"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorOutputWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var react_router_dom_1 = require("react-router-dom");
var ErrorOutputWidget = /** @class */ (function (_super) {
    __extends(ErrorOutputWidget, _super);
    function ErrorOutputWidget(props) {
        return _super.call(this, props) || this;
    }
    ErrorOutputWidget.prototype.componentDidMount = function () {
        var url = new URL(window.location.href);
        this.message = url.searchParams.get("message");
    };
    ErrorOutputWidget.prototype.render = function () {
        return (this.message ? this.renderBusinessError() : this.renderApplicationError());
    };
    ErrorOutputWidget.prototype.renderBusinessError = function () {
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsxs)("h2", { children: ["You can not make this change. ", (0, jsx_runtime_1.jsx)("br", {}), this.message] }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("div", { className: "div-margin-top", children: this.renderCancelChangesButton() })] }));
    };
    ErrorOutputWidget.prototype.renderCancelChangesButton = function () {
        return ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/customers/".concat(this.props.interaction.userReference), id: "decline-page-back", children: (0, jsx_runtime_1.jsxs)("button", { type: "button", role: "link", className: "btn btn-back", children: [" ", "Cancel changes"] }) }));
    };
    ErrorOutputWidget.prototype.renderApplicationError = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "panel error-page", children: [(0, jsx_runtime_1.jsx)("p", { className: "text-center text-uppercase mt-2 mb-0 error-title", children: "Application error" }), (0, jsx_runtime_1.jsx)("img", { className: "d-block mx-auto mb-5 icon-replace-error-laptop", src: "/img/Flourish-error.svg", alt: "Error" }), (0, jsx_runtime_1.jsx)("h2", { className: "text-center mt-3 mb-5 error-text", children: "We are experiencing some technical issues, please come back later" })] }));
    };
    return ErrorOutputWidget;
}(plugin_journey_1.WidgetBase));
exports.ErrorOutputWidget = ErrorOutputWidget;
//# sourceMappingURL=ErrorOutputWidget.js.map